<template>
  <div>
    <div class="nav">
      <div class="nav__inner">
        <div
          class="nav__line"
          v-bind:class="{ animate: line.isAnimate }"
          v-bind:style="{ width: line.width + 'px', transform: 'translate3d(' + line.offset + 'px, 0px, 0px)' }"
        ></div>
        <ul>
          <li ref="navItem" v-for="item in nav" :key="item.link">
            <router-link @click.native="gaClickNav(item.link)" :to="item.link">{{item.name}}</router-link>
            <!-- <router-link :to="item.link">{{item.name}} {{item.width}}+{{line.offset}}</router-link> -->
          </li>
        </ul>
      </div>
    </div>
    <div class="pagination">
      <div class="pagination__item pagination__item_prev">
        <router-link
          @click.native="gaClickPrev"
          :to="pagination.prev"
          class="pagination__button pagination__button_prev"
        ></router-link>
      </div>
      <div class="pagination__item pagination__item_next">
        <router-link
          @click.native="gaClickNext"
          :to="pagination.next"
          class="pagination__button pagination__button_next"
        ></router-link>
      </div>
    </div>
  </div>
</template>

<!-- eslint-disable no-param-reassign -->
<script>
export default {
  props: ["nav"],
  data() {
    return {
      line: {
        width: 0,
        offset: 0,
        isAnimate: false
      },
      pagination: {
        prev: this.$route.path,
        next: this.$route.path
      }
    };
  },
  watch: {
    $route(to) {
      const path = to.path;

      this.line.isAnimate = true;
      this.isActive(path);
    }
  },
  methods: {
    updateNavButton(index) {
      if (this.nav[index - 1]) {
        this.pagination.prev = this.nav[index - 1].link;
      }
      if (this.nav[index + 1]) {
        this.pagination.next = this.nav[index + 1].link;
      }
    },
    moveLine() {
      this.nav.forEach((item, index) => {
        item.width = this.$refs.navItem[index].clientWidth - 30;
        if (item.isActive) {
          this.line.width = item.width;
          this.line.offset = 0;
          for (let i = 0; i < index; i += 1) {
            this.line.offset += this.nav[i].width;
          }
          this.line.offset += 30 * index;
        }
      });
    },
    isActive(path) {
      path = path.replace(/\/$/, "");

      this.nav.forEach((item, index) => {
        if (item.link.indexOf(path) !== -1) {
          item.isActive = true;

          this.updateNavButton(index);
          this.$emit("updatePage");
        } else {
          item.isActive = false;
        }
      });

      this.moveLine();
    },
    gaClickNav(link) {
      let label = null;

      if (link === "/detail/digital") {
        label = "digital";
      } else if (link === "/detail/video") {
        label = "video";
      } else if (link === "/detail/events") {
        label = "btl";
      }

      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_common",
        event_action: "click",
        event_label: label
      });
    },
    gaClickPrev() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_common",
        event_action: "click",
        event_label: "prev"
      });
    },
    gaClickNext() {
      this.$gtm.trackEvent({
        event: "event",
        event_category: "wng_common",
        event_action: "click",
        event_label: "next"
      });
    }
  },
  mounted() {
    this.line.isAnimate = false;
    this.isActive(this.$route.path);
    window.addEventListener("load", () => {
      this.line.isAnimate = false;
      this.isActive(this.$route.path);
    });
  }
};
</script>

<!-- <style>
  @import '../styles/nav.css';
  @import '../styles/pagination.css';
</style> -->

<style src="@/styles/nav.css"></style>
<style src="@/styles/pagination.css"></style>



// WEBPACK FOOTER //
// src/components/nav.vue